if (typeof EventSlideshowController === 'undefined') {
	/*
	* Slideshow controller for images for an event.
	*/
	EventSlideshowController = (function ($) {

		var ret, slideshowWrapper, slideshow, count;

		function ready() {
			slideshowWrapper = $(".eventSlideshow");
			slideshow = slideshowWrapper.find('.slides');
			// Set up the slideshow.
			slick();
		}

		function slick() {
			if (typeof $.fn.slick === 'function') {
			    slideshow.on('init', window.SlickSettings.slickInit);
			    slideshow.on("afterInit", window.SlickSettings.slickAfterInit);
				slideshow.slick({
					speed: 444,
					infinite: true,
					easing: 'easeOutQuart',
					dots: false,
					prevArrow: ".eventSlideshow .prev",
					nextArrow: ".eventSlideshow .next",
				});
			}
		}

		$(ready);
		return ret;
	})(jQuery);
}